import './../scss/app.scss';

class ConnoisseurReaderData {
	constructor() {
		this.elements = document.querySelectorAll('.connoisseur-reader-data-wrapper');
	}
	init() {
		if (!this.elements.length) {
			return;
		}
		this.initializeElements();
	}

	initializeElements() {
		this.elements.forEach((element) => {
			let addSearchRow = element.querySelector('.add-search-row-link');

			let dataRows = element.querySelectorAll('.crd-data-row-wrapper');
			let json = element.getAttribute('data-json');
			json = JSON.parse(json);
			dataRows.forEach((dataRow) => {
				/* Handle select change */
				let select = dataRow.querySelector('select');
				select.addEventListener('change', (event) => {
					let value = event.target.value;
					if (!value) {
						this.clearData(dataRow);
						return;
					}
					let dataValue = json.filter((obj) => {
						return obj.name == value;
					});
					this.setData(dataRow, dataValue[0]);
				});

				/* Handle remove click */
				dataRow.querySelector('.delete-button-link').addEventListener('click', (event) => {
					event.preventDefault();
					dataRow.classList.remove('active');
					this.clearData(dataRow);

					/* Move this element to the bottom */
					dataRow.parentNode.appendChild(dataRow);

					let nextRowToShow = element.querySelector('.crd-data-row-wrapper:not(.active)');
					if (nextRowToShow) {
						addSearchRow.style.display = 'inline-block';
					}
				});
			});

			/* Show another search box */
			addSearchRow.addEventListener('click', (event) => {
				event.preventDefault();
				let rowToShow = element.querySelector('.crd-data-row-wrapper:not(.active)');
				if (rowToShow) {
					rowToShow.classList.add('active');
					let nextRowToShow = element.querySelector('.crd-data-row-wrapper:not(.active)');
					if (!nextRowToShow) {
						addSearchRow.style.display = 'none';
					}
				}
			});
		});
	}

	clearData(target) {
		target.querySelector('.buttons-wrapper .value').innerHTML = '';
		target.querySelector('.descriptive-text').innerHTML = '';
		target.querySelector('select').value = '';
	}
	setData(target, data) {
		target.querySelector('.buttons-wrapper .value').innerHTML = data.value;
		target.querySelector('.descriptive-text').innerHTML = data.descriptive_text;
		this.setMailData(target, data);
	}
	/* Set the mailto: attribute on the mail icon */
	setMailData(parent, data) {
		let target = parent.querySelector('.mail-button a');
		/* Remove html from the text */
		let text = data.descriptive_text.replace(/<[^>]*>?/gm, '');
		text += `%0D%0A%0D%0ALäs mer här: ${window.location.href}`;
		let value = `mailto:?body=${text}`;
		target.setAttribute('href', value);
	}
}
window.addEventListener('load', () => {
	window.ConnoisseurReaderData = new ConnoisseurReaderData();
	window.ConnoisseurReaderData.init();
});
